module.exports = __webpack_public_path__ + "static/media/sahithi_image.cf632e67.jpg";